import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    futureRepaymentsTitle: {
        id: '_.outstanding_view.futureRepaymentsTitle',
        defaultMessage: 'Next repayment'
    },
    futureRepayments: {
        id: '_.outstanding_view.futureRepayments',
        defaultMessage:
            "We'll automatically take your next repayment of {repaymentAmount} in {timeToRepayment} days"
    },
    futureRepaymentsCTA: {
        id: '_.outstanding_view.futureRepaymentsCTA',
        defaultMessage: 'Check your schedule'
    }
});
